import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMasterCodeControlList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceAutogenList: DataSource;
    tableAutogen: Table;
}
